import React, { useEffect, useState } from "react";
import Header from "@/components/Header";
import { api } from "@/lib/api";

export default function FAQs() {
  const [faqs, setFaqs] = useState([]);
  const [open, setOpen] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/faqs")
      .then((r) => setFaqs(r.data || []))
      .catch(() => setFaqs([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="clae-home" data-testid="faqs-page">
      <Header />
      <section className="clae-page">
        <p className="clae-eyebrow">FAQS</p>
        <h1 className="clae-h1 clae-h1--sm">FREQUENTLY<br />ASKED.</h1>
        {loading ? (
          <p className="clae-body" style={{ marginTop: 40, color: "var(--ink-soft)" }}>Loading…</p>
        ) : faqs.length === 0 ? (
          <p className="clae-body" style={{ marginTop: 40, color: "var(--ink-soft)" }}>No FAQs are available right now.</p>
        ) : (
          <ul className="clae-faq">
            {faqs.map((it, i) => (
              <li key={it.id || i} className={`clae-faq__item ${open === i ? "is-open" : ""}`} data-testid={`faq-${i}`}>
                <button className="clae-faq__q" onClick={() => setOpen(open === i ? -1 : i)}>
                  <span>{it.q}</span><span className="clae-faq__ico">{open === i ? "–" : "+"}</span>
                </button>
                {open === i && <p className="clae-faq__a">{it.a}</p>}
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
}
